<template>
  <div>
    <div class="title-wrap">
      <span class="title">快捷入口</span>
    </div>
    <ul class="quick-wrap">
      <li class="quick-item content-wrap">
        <img src="@/assets/images/quick-icon-1.png" alt="" />
        <div class="quick-content">
          <span class="text">人才招聘</span>
          <a target="_blank" href="https://ycyg.nbhr.org.cn/" class="enter-btn">点击进入</a>
        </div>
      </li>
      <li class="quick-item content-wrap">
        <img src="@/assets/images/quick-icon-2.png" alt="" />
        <div class="quick-content">
          <span class="text">人才工程</span>
          <a target="_blank" href="http://rcgc.nbrc.com.cn/#/Home" class="enter-btn">点击进入</a>
        </div>
      </li>
      <li class="quick-item content-wrap">
        <img src="@/assets/images/quick-icon-3.png" alt="" />
        <div class="quick-content">
          <span class="text">人才活动</span>
          <a href="#" class="enter-btn" @click="$router.push('/talent-activities')">点击进入</a>
        </div>
      </li>
      <li class="quick-item content-wrap">
        <img src="@/assets/images/quick-icon-4.png" alt="" />
        <div class="quick-content">
          <span class="text">揭榜挂帅</span>
          <a target="_blank" href="https://rcgj.zj.gov.cn:7005/pc/index/" class="enter-btn">点击进入</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'QuickEntry',
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
